module.exports = __webpack_public_path__ + "img/stock.4bb18cbd.png";